// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__KSvaY","info":"Note_info__zivvD","note":"Note_note__1-xqF","actions":"Note_actions__1F48Z"};